import {
  SITL_COP_TOUR_STEPS,
  type SitlCopTourStepId,
} from './sitlCopTourSteps';

/**
 * The tour runs outside React, so the SITL seat (and Layers/SitStat hosts)
 * register the UI moves they alone can perform.
 */
export type SitlCopTourApi = {
  showForms: () => void;
  openSitStat: () => void;
  openLayers: () => void;
  openPresentation: () => void;
  openAddInternalLayer: () => void;
  openReviewQueue: () => void;
  showSymbology: () => void;
};

let api: Partial<SitlCopTourApi> = {};

export function registerSitlCopTourApi(
  partial: Partial<SitlCopTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof SitlCopTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getSitlCopTourApi(): Partial<SitlCopTourApi> {
  return api;
}

export function prepareSitlCopStep(id: SitlCopTourStepId) {
  const host = getSitlCopTourApi();
  const def = SITL_COP_TOUR_STEPS.find((step) => step.id === id);

  switch (id) {
    case 'sectionIntro':
    case 'cop001':
    case 'cop001a':
    case 'focFeedback':
      host.showForms?.();
      return;
    case 'cop001b':
      host.openSitStat?.();
      host.openAddInternalLayer?.();
      return;
    case 'cop001c':
    case 'cop002a':
    case 'cop003':
    case 'cop004':
    case 'cop005':
      host.openLayers?.();
      if (id === 'cop003') host.showSymbology?.();
      return;
    case 'cop002':
    case 'cop002c':
      host.openLayers?.();
      host.openReviewQueue?.();
      return;
    case 'cop002b':
    case 'cop012Brief':
      host.openPresentation?.();
      return;
    default:
      if (def?.tour) host.showForms?.();
  }
}

export function resetSitlCopTourBridgeForTests() {
  api = {};
}
